import Colors from '../../tokens/Colors';
import styled, { css } from 'styled-components';

const Button = styled.button`
    padding: 16px 32px;
    width: ${props => props.width || '100%'};
    border: 0;
    border-radius: 8px;
    font-size: 1.6rem;
    line-height: 21.79px;
    letter-spacing: 0.02rem;
    text-align: center;
    font-weight: ${({ weight }) => (weight ? weight : 700)};
    opacity: ${({ disabled }) => (disabled ? '.7' : '1')};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};

    &:hover {
        cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    }

    &:active {
        transform: scale(0.93);
        transition: all ease 1s;
    }

    ${props =>
        props.dark &&
        css`
            color: ${Colors.white};
            background-color: ${Colors.black};

            &:hover {
                background-color: ${Colors.darkGrey};
                transition: all ease-in-out 0.5s;
            }
        `}

    ${props =>
        props.primary &&
        css`
            color: ${Colors.dark};
            background-color: ${Colors.primary};

            &:hover {
                background-color: ${Colors.primaryHover};
                transition: all ease-in-out 0.5s;
            }
        `}

        ${props =>
        props.light &&
        css`
            color: ${Colors.dark};
            background-color: ${Colors.white};

            &:hover {
                background-color: ${Colors.lightGrey};
                transition: all ease-in-out 0.5s;
            }
        `}

        ${props =>
        props.lightGrey &&
        css`
            color: ${Colors.dark};
            background-color: ${Colors.lightGrey};

            &:hover {
                opacity: 0.8;
                transition: all ease-in-out 0.5s;
            }
        `}

    ${props =>
        props.inline &&
        css`
            width: auto;
        `}
`;

export default Button;
